import type Mmenu from 'mmenu-js';

const TRIGGER_SELECTOR = '.js-mobile-menu-opener';
const MENU_SELECTOR = '.js-mobile-menu';
const menuElement = document.querySelector<HTMLElement>(MENU_SELECTOR);
const menuTriggerElements
    = document.querySelectorAll<HTMLButtonElement>(TRIGGER_SELECTOR);
const menuFooter = document.querySelector<HTMLTemplateElement>(
  '[data-template-name="mmenu-footer"]',
);

async function getMmenu(menu: HTMLElement) {
  const { default: Menu } = await import('mmenu-js');
  function beforeOpen() {
    document.body.setAttribute('data-mmenu-opened', 'true');
    for (const menuTriggerElement of menuTriggerElements) {
      menuTriggerElement.setAttribute('aria-expanded', 'true');
    }
  }

  function beforeClose() {
    document.body.setAttribute('data-mmenu-opened', 'false');
    for (const menuTriggerElement of menuTriggerElements) {
      menuTriggerElement.setAttribute('aria-expanded', 'false');
    }
  }

  return new Menu(menu, {
    slidingSubmenus: true,
    navbar: {
      title: 'Меню',
    },
    navbars: [
      {
        content: [menuFooter?.content.cloneNode(true)],
        position: 'bottom',
      },
    ],
    hooks: {
      'open:before': beforeOpen,
      'close:before': beforeClose,
    },
  });
}

export function initMobileMenu(): void {
  if (!menuElement)
    return;
  let menuInstance: Mmenu | null = null;
  for (const menuTriggerElement of menuTriggerElements) {
    // eslint-disable-next-line ts/no-misused-promises
    menuTriggerElement.addEventListener('click', async () => {
      if (!menuInstance) {
        menuInstance = await getMmenu(menuElement);
      }
      const isExpanded
              = menuTriggerElement.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        menuInstance.close();
      }
      else {
        menuInstance.open();
      }
    });
  }
}
